import { Injectable } from "@angular/core";
import { CreateFeatureGroupDto } from "../dto/create-feature-group.dto";
import { FeatureGroup } from "../model/feature-group.model";
import { ValidationUtil } from "@qid/core";
import { RestService } from "../../../../services/rest.service";

@Injectable({
  providedIn: 'root'
})
export class FeatureGroupService {

  private static readonly ApiEndpoint = 'feature-group/'

  constructor(private restService: RestService) {
  }

  create(dto: CreateFeatureGroupDto) {
    ValidationUtil.validateName(dto.name, "Name")
    ValidationUtil.validateName(dto.keyName, "Key Name")
    return this.restService.send({
      method: "POST",
      url: FeatureGroupService.ApiEndpoint,
      body: dto
    })
  }

  async readAll() {
    return (await this.restService.send<FeatureGroup[]>({
      method: "GET",
      url: FeatureGroupService.ApiEndpoint
    })).data
  }

  async update(featureGroup: FeatureGroup) {
    return (await this.restService.send<FeatureGroup[]>({
      method: "PUT",
      url: FeatureGroupService.ApiEndpoint + featureGroup._id,
      body: featureGroup,
      showErrorToast: true
    })).data
  }

  async delete(id) {
    return (await this.restService.send<FeatureGroup[]>({
      method: "DELETE",
      url: FeatureGroupService.ApiEndpoint + id,
      showErrorToast: true
    })).data
  }
}
